import { createBrowserHistory } from "history";

const history = createBrowserHistory({
  basename: process.env.BASENAME
});

export default history;



// WEBPACK FOOTER //
// ./src/redux/history.ts